import { classnames } from "../../utils/index.jsx";
import Select from "react-select";
import styles from "./Select.module.css";

export default function SelectStandalone({
  label,
  mandatory,
  isInvalid,
  error,
  className,
  hidden,
  marginForm = "margin-form",
  ...props
}) {
  return (
    <div className={classnames(styles.control, className)} hidden={hidden}>
      <label htmlFor={props.id || props.name}>
        {label}
        {mandatory && <span className={"blueStar"}> *</span>}
      </label>
      <div
        className={classnames(
          marginForm,
          styles.selectWrapper,
          isInvalid && styles.error,
        )}
      >
        <select {...props} />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 10 5"
          fill="#0C86F5"
        >
          <path d="M0 0L5 5L10 0L8 0L5 3L2 0Z" />
        </svg>
      </div>
      {isInvalid ? <div className="error marginT5">{error}</div> : null}
    </div>
  );
}

export function ReactSelectStandalone({
  isInvalid,
  error,
  className,
  placeholder,
  label,
  labelAction,
  mandatory,
  hidden,
  ...rest
}) {
  const reactSelectStyles = {
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    // Sur le fond gris d'un champ désactivé, le gris clair habituel ne se lit plus.
    placeholder: (base, state) => ({
      ...base,
      color: state.isDisabled ? "var(--color-neutral-500)" : "darkgray",
    }),
    groupHeading: (base) => ({
      ...base,
      textTransform: "none",
      color: "var(--color-text)",
      fontSize: "var(--font-size-base-medium)",
      fontWeight: "var(--font-weight-base-medium)",
      lineHeight: "var(--line-height-base-medium)",
      paddingLeft: "var(--spacing-1)",
      paddingRight: "var(--spacing-1)",
    }),
    control: ({ display }, state) => {
      let backgroundColor = "#fff",
        borderColor = "#CED4DE";
      if (state.isFocused) {
        backgroundColor = "#f2f6ff";
        borderColor = "#0C86F5";
      }
      if (isInvalid) {
        backgroundColor = "#f8d7da";
        borderColor = "#842029";
      }
      if (state.isDisabled) {
        backgroundColor = "var(--color-neutral-100)";
        borderColor = "var(--color-neutral-100)";
      }

      return {
        display,
        minHeight: "2.5rem",
        backgroundColor,
        border: "1px solid",
        borderRadius: "8px",
        borderColor: borderColor,
      };
    },
  };

  const labelElement = (
    <label htmlFor={rest.id || rest.name}>
      {label}
      {mandatory && <span className={"blueStar"}> *</span>}
    </label>
  );

  return (
    <div className={className} hidden={hidden}>
      {label && labelAction ? (
        <div className={styles.labelRow}>
          {labelElement}
          {labelAction}
        </div>
      ) : (
        label && labelElement
      )}
      <Select
        styles={reactSelectStyles}
        placeholder={placeholder ?? "Choisir une option"}
        menuPosition="fixed"
        {...rest}
      />
      {isInvalid && <div style={{ color: "#842029" }}>{error}</div>}
    </div>
  );
}
